import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import http from 'core/services/http';
import Config from 'core/config';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import JsxParser from 'react-jsx-parser';
import { ROOM_STATUS, ONLINE_PROVIDERS } from 'shared/constants';
import { isRoomOnline } from 'shared/helpers';
import { AlertMessage, AlertNotice } from 'shared/components';
import OnlineProctoringIcon from 'assets/svgs/onlineProctoring.svg';

import './RoomLtiLaunch.scss';

class RoomLtiLaunch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ltiResult: {},
      showMessage: false,
    };

    this.getLtiCode = this.getLtiCode.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
  }

  componentDidUpdate() {
    if (!isEmpty(this.state.ltiResult) && document.getElementById('lti-form')) {
      document.getElementById('lti-form').submit();
      this.setState({
        ltiResult: {},
      });
    }
  }

  getLtiCode() {
    const { room, user, tcEvent } = this.props;

    http
      .get(
        `${Config.apiUrl}/personnel/${user.id}/sign?code=${room.code}&testcentereventid=${tcEvent.id} `
      )
      .then((data) => {
        this.setState({
          ltiResult: Object.fromEntries(new URLSearchParams(data.launchString)),
          ltiUrl: data.url,
        });
      })
      .catch(() => {
        this.setState({
          showMessage: true,
        });
      });
  }

  removeMessage() {
    this.setState({
      showMessage: false,
    });
  }

  render() {
    const { tcInfo, room, tcEvent } = this.props;
    const isPsiEvent =
      !isEmpty(tcEvent) &&
      tcEvent.testingEvent?.adminId &&
      tcEvent.testingEvent.adminId.onlineProvider === ONLINE_PROVIDERS.psi;
    return (
      <div>
        {isRoomOnline(room.roomType) && (
          <div className="mt-14 mb-24">
            {(room.roomType.onlineFlag === true &&
              tcEvent.testingEvent?.adminId.onlineProvider === ONLINE_PROVIDERS.testNav) ||
            isPsiEvent ? (
              <>
                <h5>{this.props.t('testCenter.roomDashboard.onlineTesting.title')}</h5>
                <div>
                  <Link
                    className="btn btn-small btn-action m-0"
                    to={`/test-event/${tcEvent.id}/room/${room.id}/online-testing`}
                    href={`/test-event/${tcEvent.id}/room/${room.id}/online-testing`}>
                    <OnlineProctoringIcon />
                    {this.props.t('testCenter.roomDashboard.onlineTesting.buttonLabel')}
                  </Link>
                </div>
              </>
            ) : (
              <>
                <h5>{this.props.t('testCenter.roomDashboard.lti.title')}</h5>
                <div className="border-box-silver room-code-box">
                  <div className="pb-3 first-section">
                    <div
                      className={`code-section ${
                        room.status === ROOM_STATUS.inactive ? 'full-width' : ''
                      }`}>
                      {!isEmpty(tcInfo.code) && !isEmpty(room.code) ? (
                        <React.Fragment>
                          <div className="room-code">
                            {tcInfo.code &&
                              [...tcInfo.code].map((code, key) => <span key={key}>{code}</span>)}
                            <span className="delimiter">-</span>
                            {room.code &&
                              [...room.code].map((code, key) => <span key={key}>{code}</span>)}
                          </div>
                          <p className="fw-bold">
                            {this.props.t('testCenter.roomDashboard.lti.roomCodeMessage')}
                          </p>
                        </React.Fragment>
                      ) : (
                        <AlertNotice
                          message={this.props.t('testCenter.roomDashboard.lti.noCodeMessage')}
                          type="error"
                        />
                      )}
                    </div>
                    {room.status !== ROOM_STATUS.inactive && (
                      <div className="d-flex align-items-center">
                        <div onClick={this.getLtiCode} className="btn btn-action" target="_blank">
                          <span>{this.props.t('testCenter.roomDashboard.lti.proctorLabel')}</span>

                          <form
                            action={this.state.ltiUrl}
                            method="post"
                            target="_blank"
                            id="lti-form">
                            {Object.keys(this.state.ltiResult).map((key) => (
                              <input
                                type="hidden"
                                key={key}
                                name={key}
                                value={this.state.ltiResult[key]}
                              />
                            ))}
                          </form>
                        </div>
                      </div>
                    )}
                  </div>
                  {room.status !== ROOM_STATUS.inactive && (
                    <div className="border-top-gray pt-3">
                      <JsxParser
                        bindings={{
                          link: `/test-event/${tcEvent.id}/room/${room.id}/mark-test-complete`,
                        }}
                        components={{ Link }}
                        jsx={this.props.t('testCenter.roomDashboard.lti.markExamineeMessage')}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        <AlertMessage
          show={this.state.showMessage}
          time={this.state.showMessageTime}
          removeMessage={this.removeMessage}
          message="testCenter.roomDashboard.lti.getCodeError"
          isError={true}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcInfo: state.tcEvent.tcInfo || {},
    room: state.roomOptions.room || {},
    user: state.users.currentUser || {},
    tcEvent: state.tcEvent.currentEvent || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RoomLtiLaunch));

RoomLtiLaunch.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
  room: PropTypes.shape({}).isRequired,
  tcInfo: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};
